// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  staging: false,
  // hotfix: false,

  // apiURL: "https://staging.api.peliwica.easyukhosting.co.uk/api/",
  // apiURL: "http://local.peliwica.com/api/" ,
  //apiURL: "http://127.0.0.1:8000/api/" ,
  // apiURL: "http://peliwica-local.com/api/" ,
  apiURL: "https://api.peliwica.com/api/",
  // imageURL: "https://staging.api.peliwica.easyukhosting.co.uk/",
  // imageURL: "http://local.peliwica.com/",
  imageURL: "https://api.staging.peliwica.com/",
  //imageURL: "https://stagingapi.peliwica.com/",
  ADDRESSLOOKUP_API_URL: "https://api.getAddress.io/find/",
  ADDRESSLOOKUP_API_KEY: "cIc_-chj3kiI0S4t6jyUFQ27891",
  EQUINE_ID: '5dd8c0bb-b933-4f28-bc70-b5cc47fafb95',
  HHID: '24853ed2-c893-472c-8bec-d040c76cad081',
  CLIENT_WEBSITE_LINK: 'http://insuremyalpaca.co.uk/',
  FOOTER_LINK: 'https://www.cooperrosedigital.com/',
  AMLINE_API_URL: 'https://api.uat.msamlin.socrates.online/',
  AMLINE_API_URL2: 'https://api.uat.msamlin.socrates.online/',
  AMLINE_ID: '1dd8c0bb-b933-4f28-bc70-b5cc47fafb95',
  BREAKDOWN_ID: '2dd8c0bb-b933-4f28-bc70-b5cc47fafb95',
  EXCESS_PROTECT_ID: '3dd8c0bb-b933-4f28-bc70-b5cc47fafb95',
  SADDLERY_TACK_PROTECT_ID: '4dd8c0bb-b933-4f28-bc70-b5cc47fafb95',
  ALPACA_ID: '6dd8c0bb-b933-4f28-bc70-b5cc47fafb95',
  TINY_MCE_KEY: 'briu0ld3mtddfhbm6derkceaiwdg88jcis824cducuwxe35p',
  LIVESTOCK_ID: '7dd8c0bb-b933-4f28-bc70-b5cc47fafb95',
  ALLIANZ_EQUINE_ID: '8dd8c0bb-b933-4f28-bc70-b5cc47fafb95',
  AJG_ID: '9dd8c0bb-b933-4f28-bc70-b5cc47fafb95',
  NEW_EQUINE_ID: '11d8c0bb-b933-4f28-bc70-b5cc47fafb95',
  AMLINE_CLIENT_ID: 'peliwica-api',
  AMLINE_CLIENT_SECRET: '8B8CA8A6EC11B1ED9436C27C263B2',
  AMLINE_GRANT_TYPE: 'client_credentials',
  AMLINE_SCOPE: 'horsebox-api',
  UK_HB_INSURANCE_COMPANY_ID: "cb0ec00a-9d71-48dd-8b15-f9565d2976c2",
  AGRIMOTOR_ID: '12d8c0bb-b933-4f28-bc70-b5cc47fafb95',
  AGRIMOTOR_API_URL: 'https://api.uat.msamlin.socrates.online/',
  AGRIMOTOR_CLIENT_ID: 'peliwica-api',
  AGRIMOTOR_CLIENT_SECRET: '8B8CA8A6EC11B1ED9436C27C263B2',
  AGRIMOTOR_GRANT_TYPE: 'clienk_credentials',
  AGRIMOTOR_SCOPE: 'agri-api',
  showAmlinAddonProducts:true,
  showAgriMotor: true,
};


/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
